export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/324f3315b17f0caa3e4147c2a172e9ba.png";